import React from 'react';
import { Form, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivel1 = props => {
  return (
    <option>{props.elemento.descrMetodo}</option>
  )
  };
  
const ListaM = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrMetodo" id="miLista1" value={permiteUpdate?argsDocum.descrMetodo:idLista.descrMetodo?idLista.descrMetodo:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
const DetalleNivel2 = props => {
  return (
    <option>{props.elemento.descrTarea}</option>
  )
  };
  
const ListaT = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrTarea" id="miLista2" value={permiteUpdate?argsDocum.descrTarea:idLista.descrTarea?idLista.descrTarea:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel2Detalle}
      </select>
    </div>
  )
};

const ListaMod = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="modoTarea" id="miLista6" value={permiteUpdate?argsDocum.modoTarea:idLista.modoTarea?idLista.modoTarea='I'?'Equipo en operación':idLista.modoTarea='O'?'Equipo detenido':'Seleccionar...':'Seleccionar...'} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Equipo en operación</option>
        <option>Equipo detenido</option>
      </select>
    </div>
  )
};
const ListaSISO = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="requiereSISO" id="miLista7" value={permiteUpdate?argsDocum.requiereSISO:idLista.requiereSISO?idLista.requiereSISO='Si'?'Si requiere SISO':idLista.requiereSISO='No'?'No requiere SISO':'Seleccionar...':'Seleccionar...'} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Si requiere SISO</option>
        <option>No requiere SISO</option>
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  return (
    <option dato1={props.elemento.nombreArchivo}>{props.elemento.codProcedimiento}</option>
  )
  };
  
const ListaP = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleNivel3 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="codProcedimiento" id="miLista3" value={permiteUpdate?argsDocum.codProcedimiento:idLista.codProcedimiento?idLista.codProcedimiento:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel3Detalle}
      </select>
    </div>
  )
};
const DetalleNivel4 = props => {
  return (
    <option>{props.elemento.descrFrecuencia}</option>
  )
  };
  
const ListaF = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleNivel4 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrFrecuencia" id="miLista4" value={permiteUpdate?argsDocum.descrFrecuencia:idLista.descrFrecuencia?idLista.descrFrecuencia:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel4Detalle}
      </select>
    </div>
  )
};
const DetalleNivel5 = props => {
  return (
    <option>{props.elemento.descrFrecuencia}</option>
  )
};
const ListaFr = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel5Detalle = list.map((elemento, _id) => <DetalleNivel5 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrFrecuenciaPre" id="miLista5" value={permiteUpdate?argsDocum.descrFrecuenciaPre:idLista.descrFrecuenciaPre?idLista.descrFrecuenciaPre:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel5Detalle}
      </select>
    </div>
  )
};

class VerProg2 extends React.Component {
  state={
    argsDocum: {descrPlanta: this.props.idLista.descrPlanta,
                descrSeccion: this.props.idLista.descrSeccion,
                descrEquipo: this.props.idLista.descrEquipo,
                descrComponente: this.props.idLista.descrComponente,
                descrMecanismo: this.props.idLista.descrMecanismo,
                descrMetodo: this.props.idLista.descrMetodo,
                descrTarea: this.props.idLista.descrTarea, 
                modoTarea: this.props.idLista.modoTarea?this.props.idLista.modoTarea='I'?'Equipo en operación':this.props.idLista.modoTarea='O'?'Equipo detenido':'Seleccionar...':'Seleccionar...',
                requiereSISO: this.props.idLista.requiereSISO?this.props.idLista.requiereSISO='Si'?'Si requiere SISO':this.props.idLista.requiereSISO='No'?'No requiere SISO':'Seleccionar...':'Seleccionar...',
                descrFrecuencia: this.props.idLista.descrFrecuencia,
                descrFrecuenciaPre: this.props.idLista.descrFrecuenciaPre?this.props.idLista.descrFrecuenciaPre:'',
                cantidad: this.props.idLista.cantidad?this.props.idLista.cantidad:0,
                minutos: this.props.idLista.minutos?this.props.idLista.minutos:0,
                puntosLub: this.props.idLista.puntosLub?this.props.idLista.puntosLub:0,
                descrEmpresa: this.props.idLista.descrEmpresa,
                tipoFrecuencia: this.props.idLista.tipoFrecuencia?this.props.idLista.tipoFrecuencia:'',
                fechaProx: this.props.idLista.fechaProx?this.props.idLista.fechaProx:'',
                codProcedimiento: this.props.idLista.codProcedimiento?this.props.idLista.codProcedimiento:"Seleccionar...",
                nombreArchivo: this.props.idLista.nombreArchivo?this.props.idLista.nombreArchivo:'',
                acumProx: this.props.idLista.acumProx?parseInt(this.props.idLista.acumProx):0
              },
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "descrPlanta" && ev.target.name !== "descrSeccion" && ev.target.name !== "descrEquipo"
          && ev.target.name !== "descrComponente"  && ev.target.name !== "descrMecanismo"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "codProcedimiento"){
          let miLista = document.getElementById("miLista3");
          argsDocum['codProcedimiento'] = miLista.options[miLista.selectedIndex].text
          argsDocum['nombreArchivo'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click() 
    }
  }
  
  render(){
    const {argsDocum, open, confirmaAct} = this.state;

    let descrMetodoAnt = this.props.idLista.descrMetodo
    let descrTareaAnt = this.props.idLista.descrTarea

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          {this.props.idLista.descrPlanta} - {this.props.idLista.descrSeccion} - {this.props.idLista.descrEquipo} - {this.props.idLista.descrComponente} - {this.props.idLista.descrMecanismo}
        </button>
        {/* <div style={this.props.styles.backGr_2}> */}
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum,
              descrMetodoAnt, descrTareaAnt):()=>{}}>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Planta</label>
                    <Form.Input autoComplete="off" name="descrPlanta" id="descrPlanta" value={this.props.permiteUpdate?argsDocum.descrPlanta:this.props.idLista.descrPlanta} onChange={this.handleChange} placeholder='Descripción Planta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrPlanta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Sección</label>
                    <Form.Input autoComplete="off" name="descrSeccion" id="descrSeccion" value={this.props.permiteUpdate?argsDocum.descrSeccion:this.props.idLista.descrSeccion} onChange={this.handleChange} placeholder='Descripción Sección' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrSeccion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Equipo</label>
                    <Form.Input autoComplete="off" name="descrEquipo" id="descrEquipo" value={this.props.permiteUpdate?argsDocum.descrEquipo:this.props.idLista.descrEquipo} onChange={this.handleChange} placeholder='Descripción Equipo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrEquipo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Componente</label>
                    <Form.Input autoComplete="off" name="descrComponente" id="descrComponente" value={this.props.permiteUpdate?argsDocum.descrComponente:this.props.idLista.descrComponente} onChange={this.handleChange} placeholder='Descripción componente' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrComponente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "30%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción mecanismo</label>
                    <Form.Input autoComplete="off" name="descrMecanismo" id="descrMecanismo" value={this.props.permiteUpdate?argsDocum.descrMecanismo:this.props.idLista.descrMecanismo} onChange={this.handleChange} placeholder='Descripción mecanismo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrMecanismo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>              
              </div>
            </div>

            <Divider inverted />

            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Método</label>
                    <ListaM list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Tarea</label>
                    <ListaT list={this.props.list10} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                
                </div>
                <div className="column" style={{width: "13%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Modo de ejec. de la tarea</label>
                    <ListaMod styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                
                </div>
                <div className="column" style={{width: "12%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Requiere SISO</label>
                    <ListaSISO styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                
                </div>                
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Procedimiento</label>
                    <ListaP list={this.props.list11} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>                              
              </div>
            </div>
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción frecuencia</label>
                    <ListaF list={this.props.list12} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    {argsDocum.descrFrecuencia==='Predictiva' &&
                      <ListaFr list={this.props.list13} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    }                    
                  </Form.Field>
                </div>
                <div className="column" style={{width: "12%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Puntos a lub.</label>
                    <Form.Input type='number' step="1" min="0" autoComplete="off" name="puntosLub" id="puntosLub" value={this.props.permiteUpdate?argsDocum.puntosLub:this.props.idLista.puntosLub?this.props.idLista.puntosLub:0} onChange={this.handleChange} placeholder='Puntos a lub.' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'puntosLub'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>                
                <div className="column" style={{width: "12%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Cantidad de lub.</label>
                    <Form.Input type='number' step="0.001" min="0" autoComplete="off" name="cantidad" id="cantidad" value={this.props.permiteUpdate?argsDocum.cantidad:this.props.idLista.cantidad?this.props.idLista.cantidad:0} onChange={this.handleChange} placeholder='Cantidad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'cantidad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "11%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Minutos ejec.</label>
                    <Form.Input type='number' step="1" min="0" autoComplete="off" name="minutos" id="minutos" value={this.props.permiteUpdate?argsDocum.minutos:this.props.idLista.minutos?this.props.idLista.minutos:0} onChange={this.handleChange} placeholder='Minutos' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'minutos'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>          
                <div className="column" style={{width: "30%"}}>
                  {argsDocum.tipoFrecuencia==='Calendario' &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Fecha prox ejec</label>
                      <input style={this.props.styles.input} type='date' name="fechaProx" id="fechaProx" value={argsDocum.fechaProx} onChange={this.handleChange}/>
                    </Form.Field>                
                  }
                  {argsDocum.tipoFrecuencia!=='Calendario' && 
                    <Form.Field>
                      <label style={this.props.styles.label}>Acum prox ejec</label>
                      <Form.Input type='number' step="1" min="0" autoComplete="off" name="acumProx" id="acumProx" value={this.props.permiteUpdate?argsDocum.acumProx:this.props.idLista.acumProx} onChange={this.handleChange} placeholder='Acum prox ejec' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'acumProx'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>                
                  }                        
                </div>
              </div>
            </div>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerProg2
